export default __webpack_public_path__ + "static/media/tuat.13a146f6.svg";